export default {
    report: 'รายงาน',
    dailyReport: 'รายงานรายวัน',
    monthlyReport: 'รายงานรายเดือน',
    empMonthlyLogReport: 'รายงานบันทึกประจำเดือนของพนักงาน',
    monthlyRecordingReport: 'รายงานบันทึกประจำเดือน',
    OvertimeMonthlyReport: 'รายงาน OT ประจำเดือน',
    allBranch: 'ทุกสาขา',
    attendanceReport: 'การลงชื่อเข้างาน',
    visitorReport: 'กิจกรรมผู้เยี่ยมชม'
}
